import {
  PaxCheckDocumentMrzConfiguration,
  PaxCheckDocumentSidesExpectation,
} from "api";
import AllowedDocument from "models/documents/allowed-document";
import ScannerDocumentConfig, {
  ScanDocumentSidesMode,
} from "models/scanner-document-config";
import { ScannerInstanceType } from "models/scanner-type";

import ScannerError from "../../models/scanner-error";
import { MultiPaxSessionId } from "models/session/session";

export interface IScanner {
  init(
    sessionId: MultiPaxSessionId,
    onError: (e: ScannerError) => void,
    onSuccess: (type: ScannerInstanceType) => void
  ): any;

  isLowResCheckSupported(): [boolean, number | undefined];

  canUseSingleScannerInstance(docs: AllowedDocument[]): boolean;
}

export const getScannerDocumentConfig = (
  docs: AllowedDocument[]
): ScannerDocumentConfig => {
  const mode = () => {
    const isAnyMultiSide = docs.some((doc) => doc.isMultiSideExpected());

    if (isAnyMultiSide) {
      return ScanDocumentSidesMode.MultiSide;
    }

    const uniqueSidesExpectations = docs
      .map((docs) => docs.sidesExpectation)
      .filter((value, index, self) => self.indexOf(value) === index);

    const isCardFrontOrDataPage =
      uniqueSidesExpectations.includes(
        PaxCheckDocumentSidesExpectation.DATA_PAGE
      ) &&
      uniqueSidesExpectations.includes(
        PaxCheckDocumentSidesExpectation.CARD_FRONT
      );

    const isCardBackOrDataPage =
      uniqueSidesExpectations.includes(
        PaxCheckDocumentSidesExpectation.DATA_PAGE
      ) &&
      uniqueSidesExpectations.includes(
        PaxCheckDocumentSidesExpectation.CARD_BACK
      );

    const isCardFrontOnly = uniqueSidesExpectations.every(
      (side) => side === PaxCheckDocumentSidesExpectation.CARD_FRONT
    );

    const isCardBackOnly = uniqueSidesExpectations.every(
      (side) => side === PaxCheckDocumentSidesExpectation.CARD_BACK
    );

    if (isCardBackOrDataPage) {
      return ScanDocumentSidesMode.CardBackOrDataPage;
    }

    if (isCardFrontOrDataPage) {
      return ScanDocumentSidesMode.CardFrontOrDataPage;
    }

    if (isCardBackOnly) {
      return ScanDocumentSidesMode.OnlyCardBack;
    }

    if (isCardFrontOnly) {
      return ScanDocumentSidesMode.OnlyCardFront;
    }

    return ScanDocumentSidesMode.OnlyDataPage;
  };

  const shouldEnforceMrz = docs.every(
    (doc) => doc.sideWithMrz !== PaxCheckDocumentMrzConfiguration.NONE
  );

  return new ScannerDocumentConfig({
    shouldEnforceMrz: shouldEnforceMrz,
    mode: mode(),
  });
};
